import axios from "axios";
import {getToken} from "@/utils/token.js";
import {Modal, message as Message} from 'ant-design-vue';

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: import.meta.env.VITE_APP_BASE_API,
    // 超时
    timeout: 10000
})

const AUTH_HEADER = import.meta.env.VITE_APP_AUTH_HEADER;

// request拦截器
service.interceptors.request.use(config => {
    // 有token就携带token
    const token = getToken();
    if (token) {
        // config.headers[AUTH_HEADER] = 'Bearer ' + token
        config.headers[AUTH_HEADER] = token
    }

    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // console.log('res__', res);
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = res.data.msg || "系统异常, 请联系管理员"
        // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data
        }
        if (code === 401) {

            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        } else if (code === 500) {
            Message.error(msg)
            return Promise.reject(new Error(msg))
        } else if (code === 400) {
            Message.warning(msg);
            return Promise.reject(new Error(msg));
        } else if (code !== 200) {
            Message.warning(msg);
            return Promise.reject('error')
        } else {
            return Promise.resolve(res.data)
        }
    },
    error => {
        let {message} = error;
        if (message === "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substring(message.length - 3) + "异常";
        }
        Message.error(message, 3)
        return Promise.reject(error)
    }
)

export default service;
